// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"476":"883e59982dde95a0","496":"46dbb6c71b51853d","871":"b72d457c869e0bd5"}[chunkId] + ".js";
};